import ProjectLayout from "../ProjectLayout";
import "../ProjectPage.css";

export default function MeditationPage() {

  return (
    <ProjectLayout
      title="Space Breathwork Application"
      role="Unity Developer (C#)"
      team="1"
      duration="2 Weeks"
      engine="Unity (C#)"
      about="Space Breathwork is a breathwork application built in Unity to help people engage in various breathwork practices in a relaxing 3D space environment."
      videoSrc={`https://neurogoblin-videos.s3.us-east-2.amazonaws.com/space.mp4`}
      playLink={`${process.env.PUBLIC_URL}/space-breathwork`}
      playText={"🚀 Play Now"}
      galleryImages = {[
        `${process.env.PUBLIC_URL}/img/space/1.png`,
        `${process.env.PUBLIC_URL}/img/space/2.png`,
        `${process.env.PUBLIC_URL}/img/space/3.png`,
        `${process.env.PUBLIC_URL}/img/space/4.png`,
      ]}
    >
      <section>
        <h2>Introduction</h2>
        <p>
          Space Breathwork is a simple Unity app built for the web that provides
          users a relaxing way to engage in breathwork practices. The user can
          choose whether to have a calming or energetic effect, and they can
          change the timing of their inhales and exhales.
        </p>
      </section>

      <section>
        <h2>What I Learned</h2>
        <p>
          This app helped me learn how to manipulate shaders, as the breathing
          orb changes in response to your inhales and exhales. I also learned
          about procedural generation of the asteroids in the background of the
          scene.
        </p>
      </section>


    </ProjectLayout>
  );
}
